import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { priceService } from '../services/priceService';
import { useStore } from '../../../store/useStore';

export const usePromotionSync = () => {
    const navigate = useNavigate();
    const { promotions, addPromotion, updatePromotion } = useStore();
    const [loading, setLoading] = useState(false);

    const syncWithCheckout = async () => {
        try {
            setLoading(true);

            let allItems: any[] = [];
            let currentPage = 1;
            let hasMore = true;
            const pageSize = 100;

            // Buscar todas as páginas
            while (hasMore) {
                const result: any = await priceService.listarPrecos({
                    page: currentPage,
                    pageSize
                });

                // A API retorna { items: [], hasNext: boolean }
                const items = result.items || [];
                allItems = [...allItems, ...items];

                hasMore = result.hasNext || false;
                currentPage++;

                // Limite de segurança para evitar loop infinito
                if (currentPage > 50) break;
            }

            let addedCount = 0;
            let updatedCount = 0;

            const today = new Date();
            const nextWeek = new Date(today);
            nextWeek.setDate(today.getDate() + 7);
            const validUntil = nextWeek.toISOString().split('T')[0];

            // Processar todos os itens
            allItems.forEach(item => {
                const existingPromo = promotions.find(p => p.id === item.produtoId);

                const preco = Number(item.vlPrecoNormal || item.preco || 0);
                const precoPromocional = Number(item.vlPreco || item.precoPromocional || 0);
                const emPromocao = item.promocao === true || item.promocao === 'true' ||
                    item.emPromocao === true || item.emPromocao === 'true';
                const nome = item.nome || item.descricao || `Produto ${item.produtoId}`;

                const promoData: any = {
                    name: nome,
                    price: emPromocao && precoPromocional > 0 ? precoPromocional : (preco > 0 ? preco : 0),
                    originalPrice: emPromocao && preco > 0 ? preco : undefined,
                    unit: item.tipoUnidade || item.unidade || 'UN',
                    category: 'Frente de Caixa',
                    validUntil: validUntil,
                    description: `Código: ${item.produtoId}${emPromocao ? ' - EM PROMOÇÃO' : ''}`,
                    isVideoPromotion: false,
                    hasAudio: true,
                    autoplay: true,
                    loop: true,
                    createdAt: new Date().toISOString()
                };

                if (existingPromo) {
                    updatePromotion(item.produtoId, promoData);
                    updatedCount++;
                } else {
                    addPromotion(promoData, item.produtoId);
                    addedCount++;
                }
            });

            alert(`Sincronização concluída!\n${addedCount} itens adicionados\n${updatedCount} itens atualizados\nTotal: ${allItems.length} produtos`);
        } catch (error: any) {
            if (error.message === 'Não autorizado') {
                alert('Sessão expirada. Por favor, faça login novamente.');
                navigate('/login');
            } else {
                alert('Erro ao sincronizar com frente de caixa. Verifique o console para mais detalhes.');
            }
        } finally {
            setLoading(false);
        }
    };

    return {
        syncWithCheckout,
        loading
    };
};
